<template>
  <div class="share-popup" v-if="open">
    <transition name="popup-modal">
      <PopupBase
        v-if="open"
        @close="$emit('close')"
        :show-header-notice-icon="false"
      >
        <template #header-text>Samenstelling delen</template>
        <template #body>
          <div class="content-wrapper">
            <p class="description">
              Kopieer de link om te delen of informeer iemand anders over dit
              schakelmateriaal via e-mail of WhatsApp. Op deze manier kun je
              eenvoudig de exacte samenstelling delen of voor je eigen
              naslagwerk gebruiken en later opzoeken.
            </p>
          </div>
          <div class="form">
            <div class="build-link-input">
              <transition
                name="fade"
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
              >
                <span v-if="linkCopied" class="copied-link-tooltip">
                  Link gekopieerd naar je klembord
                </span>
              </transition>
              <EmatInput :disabled="true" v-model="buildIdUrl" />
              <button
                class="emat-btn emat-btn-primary copy-link-button"
                @click="copyBuildId"
              >
                Kopieer link
              </button>
            </div>

            <div class="share-link-buttons">
              <a
                target="_blank"
                :href="'https://wa.me/?text=' + buildIdUrl"
                class="emat-btn share-button whatsapp"
              >
                <img
                  class="share-icon"
                  :src="getIcon('whatsapp-icon-white.svg')"
                  alt="whatsapp"
                />
              </a>

              <a
                target="_blank"
                :href="
                  'mailto:?subject=Samenstelling%20schakelmateriaal&body=' +
                  encodeURIComponent(
                    'Beste meneer/mevrouw,\n\n' +
                      'Via de schakelmateriaal generator van Elektramat heb ik een samenstelling gemaakt. \n' +
                      'Hieronder is de link weergegeven waarmee je de samenstelling kunt openen.\n\n' +
                      buildIdUrl +
                      '\nHet is mogelijk om nog wijzigingen door te voeren, wanneer dit nodig is. \n\n' +
                      'Met vriendelijke groet,'
                  )
                "
                class="emat-btn share-button emat-btn-primary"
              >
                <img
                  class="share-icon"
                  :src="getIcon('mail-envelope-icon-white.svg')"
                  alt="mail-envelope"
                />
              </a>
            </div>
          </div>
        </template>
      </PopupBase>
    </transition>
  </div>
</template>

<script>
import PopupBase from '@/components/popups/PopupBase.vue';
import EmatInput from '@/components/form/EmatInput.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SharePopup',
  components: { EmatInput, PopupBase },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      linkCopied: false,
    };
  },
  computed: {
    ...mapGetters('build', ['getRoomGuids']),
    buildIdUrl() {
      const urlParams = new URLSearchParams(window.location.search);

      const querySeparator = urlParams.size > 0 ? '&' : '';
      // prettier-ignore
      const buildsParam = `${querySeparator}builds=${this.getRoomGuids.join(',')}`;

      // prettier-ignore
      return `${window.location.origin}${window.location.pathname}?${urlParams.toString()}${buildsParam}`;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },

    copyBuildId() {
      navigator.clipboard.writeText(this.buildIdUrl).then(() => {
        this.linkCopied = true;
        setTimeout(() => {
          this.linkCopied = false;
        }, 3000);
      });
    },
  },
};
</script>
